var _path, _g, _path2, _path3, _g2, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEthizo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 22,
    viewBox: "0 0 80 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_37_98",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5H17V22H0V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_37_98)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2924 15.9067L4.09183 13.5598L12.8197 9.76137C11.823 8.42281 10.4171 7.75342 8.60141 7.75342C7.05605 7.75342 5.74905 8.29627 4.68082 9.38259C3.61239 10.4687 3.07838 11.7866 3.07838 13.3357C3.07838 14.9862 3.60821 16.367 4.66807 17.4784C5.72772 18.5899 7.08135 19.1455 8.72812 19.1455C11.3712 19.1455 13.1955 17.6426 14.2003 14.6366L17 15.2807C15.3785 19.7602 12.6127 22 8.70282 22C6.34662 22 4.30698 21.1707 2.58431 19.512C0.861646 17.8532 0 15.8534 0 13.5127C0 11.1214 0.827565 9.1047 2.4829 7.46282C4.13803 5.82094 6.16931 5 8.57674 5C12.2249 5 14.9781 6.94582 16.8363 10.8375L5.2924 15.9067Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 16.2334V3H22.7096V6.56656H28V9.13317H22.7096V16.4668C22.7096 16.9783 22.7848 17.4281 22.9354 17.8166C23.0856 18.2058 23.6235 18.4001 24.5483 18.4001L27.7742 18.3666V20.9334H24.3225C24.3009 20.956 24.2687 20.9725 24.2257 20.9833C24.1825 20.9948 24.1501 21 24.1291 21H24.0161H23.9033C22.634 21 21.6985 20.5835 21.0967 19.7502C20.4944 18.9166 20.1396 17.9892 20.0322 16.9667C20.0322 16.856 20.0268 16.7392 20.016 16.6166C20.005 16.4949 20 16.3781 20 16.2667V16.2334Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_37_98",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 0,
    width: 13,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 0H42V21H29V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_37_98)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.72 0V7.80013C32.3322 7.35577 32.9797 6.97816 33.6631 6.66669C34.3458 6.35564 35.1345 6.20021 36.03 6.20021C37.6309 6.20021 39.0264 6.6392 40.216 7.51677C41.4049 8.39496 42 9.60011 42 11.1335V21H39.2445V12.5C39.2445 11.3447 38.9144 10.4334 38.2554 9.7667C37.5956 9.10015 36.7716 8.76678 35.7824 8.76678C34.6047 8.76678 33.7158 9.05572 33.1155 9.63339C32.5149 10.2115 32.1086 10.8447 31.8967 11.5334C31.826 11.7333 31.7787 11.9391 31.7553 12.1501C31.7318 12.3614 31.72 12.5666 31.72 12.7667V21H29V0H31.72Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 21H49V7H46V21ZM46 3.40007C46 2.93338 46.1464 2.58347 46.4393 2.34991C46.7321 2.11657 47.0909 2 47.5152 2C47.5757 2 47.6411 2.00579 47.7121 2.01674C47.7828 2.02832 47.8486 2.04485 47.9092 2.06676C48.1918 2.13331 48.4442 2.28336 48.6669 2.51671C48.8889 2.75005 49 3.05574 49 3.43335C49 3.92256 48.8532 4.30017 48.5607 4.56679C48.2676 4.83341 47.9495 4.97809 47.606 5H47.5607H47.5152C47.1312 5 46.7828 4.86669 46.4697 4.60007C46.1563 4.33345 46 3.94488 46 3.43335V3.40007Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3436 7C62.2062 7.0233 62.8304 7.24942 63.2168 7.67857C63.6024 8.10815 63.7956 8.58908 63.7956 9.12265C63.7956 9.23895 63.7899 9.34877 63.7787 9.4532C63.7671 9.55763 63.7388 9.66788 63.6936 9.78374C63.6254 10.0856 63.5116 10.3812 63.353 10.6712C63.194 10.9614 63.0008 11.2222 62.774 11.4542L56.2354 19.562H64V21.9977H55.0434C54.4984 22.021 54.0216 21.8644 53.613 21.5278C53.2044 21.1917 53 20.7683 53 20.2576C53 20.0958 53.0224 19.9273 53.0682 19.7532C53.1132 19.5793 53.1816 19.4 53.2724 19.2138C53.3406 19.0746 53.4257 18.9354 53.5279 18.7963C53.6301 18.6571 53.7374 18.518 53.8516 18.3786L60.6284 9.67932H53.613V7H61.3436Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5 22C68.3579 22 65 18.6421 65 14.5C65 10.3579 68.3579 7 72.5 7C76.6421 7 80 10.3579 80 14.5C80 18.6421 76.6421 22 72.5 22ZM72.5 19C74.9853 19 77 16.9853 77 14.5C77 12.0147 74.9853 10 72.5 10C70.0147 10 68 12.0147 68 14.5C68 16.9853 70.0147 19 72.5 19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEthizo);
export default __webpack_public_path__ + "static/media/ic-ethizo.306017a3245012592461f55b68fa1c1c.svg";
export { ForwardRef as ReactComponent };